const LATEST_VERSION = 1;

/**
* Migrations for an individual "ContactPlanner" widget of the event site editor website layout item.
* These are event specific migrations to apply to existing websites so that
* event website specific breaking changes can be compatible with them.
*/
export default function contactPlannerWidgetMigrations(contactPlanner) {
  if (contactPlanner.eventVersion === LATEST_VERSION) {
    return contactPlanner;
  }
  const migratedContactPlanner = { ...contactPlanner };
  if (!migratedContactPlanner.eventVersion) {
    migratedContactPlanner.eventVersion = 1;

    // Add the new button text property if it is missing.
    if (!migratedContactPlanner.config.buttonText) {
      migratedContactPlanner.config = {
        ...migratedContactPlanner.config,
        buttonText: { htmlContent: '_contactPlanner_buttonText__resx', editorState: null }
      };
    }
  }
  return migratedContactPlanner;
}
